export default function OtherServices() {
    return (
        <div className="flex items-center justify-center h-[400px]">
            <h2 className="text-2xl font-semibold text-gray-700">Dịch vụ khác đang được phát triển...</h2>
        </div>
    );
}